import { ResourceLink } from "@/components/ImplementationGuide/types";

const professionalLearningResources: ResourceLink[] = [
  {
    question_text:
      "Your district has purchased professional learning support. We recommend starting your first session within the first 60 days of using Newsela.",
    url: "https://go.newsela.com/rs/628-ZPE-510/images/A_Successful_Year_of_Newsela_Professional_Learning.pdf?version=0",
    label: "Suggested professional learning sessions",
    hasPurchasedProfessionalLearning: true,
  },
  {
    question_text:
      "We recommend starting your first professional learning within the first 60 days of using Newsela.",
    url: "https://newsela.com/about/drive-outcomes/",
    label: "Self service learning",
    hasPurchasedProfessionalLearning: false,
  },
];

export default professionalLearningResources;
